var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('MainLayout'),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"hand-wapp",attrs:{"href":"https://wa.me/595986130808","target":"_blank"}},[_c('img',{attrs:{"src":require("./assets/img/whatsapp.png"),"borde":"0","alt":"Whatsapp"}})])
}]

export { render, staticRenderFns }